import React, { useState } from "react";
import { Modal, TextField, Button, Box } from "@mui/material";
import {  H5 } from "./Typography";
import { load } from "../constants/storage";
import { userPincode } from "../redux/actions/LoginAction";
import { useAppDispatch } from "../store/hooks";
import toast from "react-hot-toast";
import { PincodeRequest } from "../models";
import { maxPhoneLength, pincodeLength } from "../common/common";

type FormValues = {
  username: string;
  addressmobile: string;
  address: string;
  pincode: string;
  city: string;
  state: string;
};

type FormErrors = {
  username?: string;
  addressmobile?: string;
  address?: string;
  pincode?: string;
  city?: string;
  state?: string;
};

type MyModalProps = {
  open: boolean;
  handleClose: () => void;
  handleSave: (value: any) => void;
};

function AddAddressModal({ open, handleClose, handleSave }: MyModalProps) {
  const [formValues, setFormValues] = useState<FormValues>({
    username: "",
    addressmobile: "",
    address: "",
    pincode: "",
    city: "",
    state: "",
  });
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const dispatch = useAppDispatch();
  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" }); // clear any previous errors for this field
  }

  const handleTextBlur = () => {
    getUserPincode();
  };

  const getUserPincode = async () => {
    let token = load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const data: PincodeRequest = {
      id: userDetails?.id,
      mobile: userDetails?.mobile,
      partner: userDetails.refcode,
      pincode: formValues.pincode,
    };
    dispatch(userPincode(data, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.message === "Pincode details fetch Successfully") {
          setFormValues((prevState) => ({
            ...prevState,
            city: response.bankdata?.data?.city || "",
          }));
          setFormValues((prevState) => ({
            ...prevState,
            state: response.bankdata?.data?.state || "",
          }));
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };
  const handleSaveClick = () => {
    const regex = /^[0-9\b]+$/;
    const mobileRegrex = /^(\+91|0)?[6789]\d{9}$/
    const newErrors: FormErrors = {};
    if (!formValues.username) {
      newErrors.username = "Name cannot be empty.";
    }
    if (!formValues.addressmobile) {
      newErrors.addressmobile = "Mobile number cannot be empty.";
    }
    if (!regex?.test(formValues.addressmobile)) {
      newErrors.addressmobile = "Please enter a valid mobile number.";
    }
    if (formValues.addressmobile.length > 10) {
      newErrors.addressmobile = "Please enter a valid indian mobile number.";
    }
    if (!mobileRegrex?.test(formValues.addressmobile)) {
      newErrors.addressmobile = "Please enter a valid mobile number.";
    }
    if (!formValues.address) {
      newErrors.address = "Address cannot be empty.";
    }
    if (!formValues.pincode) {
      newErrors.pincode = "Pincode  cannot be empty.";
    }
    if (!formValues.state) {
      newErrors.state = "State cannot be empty.";
    }
    if (!formValues.city) {
      newErrors.city = "City cannot be empty.";
    }
    // if there are errors, update state with them
    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
    } else {
      handleSave(formValues);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Box sx={header}>
          <H5
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              p: 1.5,
              color: "#ffff",
              textTransform: 'none'
            }}
            fontWeight={"500"}
          >
            Add Address
          </H5>
        </Box>
        <Box sx={container}>
          <TextField
            label="Name"
            name="username"
            value={formValues.username ? formValues.username : ""}
            error={!!formErrors.username}
            helperText={formErrors.username}
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            sx={textInputStyles}
            // InputProps={{
            //   style: {
            //     height: "40px", // change this value to set the desired height
            //   },
            // }}
          />
          <TextField
            label="Mobile Number"
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            inputProps={{
              maxLength: maxPhoneLength,
            }}
            sx={textInputStyles}
            name="addressmobile"
            value={formValues.addressmobile ? formValues.addressmobile : ""}
            error={!!formErrors.addressmobile}
            helperText={formErrors.addressmobile}
          />
          <TextField
            label="Address"
            // value={value}
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            sx={textInputStyles}
            name="address"
            value={formValues.address ? formValues.address : ""}
            error={!!formErrors.address}
            helperText={formErrors.address}
          />
          <TextField
            label="PinCode"
            // value={value}
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            onBlur={handleTextBlur}
            inputProps={{
              maxLength: pincodeLength,
            }}
            sx={textInputStyles}
            name="pincode"
            value={formValues.pincode ? formValues.pincode : ""}
            error={!!formErrors.pincode}
            helperText={formErrors.pincode}
          />
          <TextField
            label="City"
            disabled
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            sx={textInputStyles}
            name="city"
            value={formValues.city ? formValues.city : ""}
            error={!!formErrors.city}
            helperText={formErrors.city}
          />
          <TextField
            label="State"
            disabled
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            margin="normal"
            sx={textInputStyles}
            name="state"
            value={formValues.state ? formValues.state : ""}
            error={!!formErrors.state}
            helperText={formErrors.state}
          />
          <Box sx={buttonContainer}>
            <Button variant="contained" onClick={handleClose} sx={[cancel,{textTransform: 'none'}]}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSaveClick} sx={[add,{textTransform: 'none'}]}>
              Add
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default AddAddressModal;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    md: "30%",
    xs: "90%",
  },
  bgcolor: "background.paper",
  overflowY: 'scroll',
  boxShadow: 4,

  borderRadius: 2,
  overflow: "hidden",
};
const header = {
  width: "100%",
  bgcolor: process.env.REACT_APP_PRIMARY_COLOR,

  boxShadow: 4,
};
const container = {
  pl: 2,
  pr: 2,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  pb:1.5,
  pt:2
};

const buttonContainer = {
  width: "100%",
  justifyContent: "space-between",
  flexDirection: {
    md: "row",
    xs: "column",
  },
  display: "flex",

  mt: {
    md: 2.5,
    xs: 1,
  },
};


const cancel = {
  background: "#FFF5D1",
  color: "#000",
  width: {
    md: "45%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
const add = {
  background:process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "45%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "94%",
  },
  marginTop: {
    xs: 2,
    sm: 2,
    md: 1.5,
  },
};
